import IEmailAccount from "../types/IEmailAccount";

/**
 * Resolves the charity default sending identity: Redis (admin-service) first, then Firebase internal/emails/defaultEmail.
 */
export function mergeSendingEmailDefault(
  redis: IEmailAccount | null | undefined,
  firebase: IEmailAccount | null | undefined
): IEmailAccount {
  if (redis != null && String(redis.email || "").length > 0) {
    return redis;
  }
  if (firebase != null && String(firebase.email || "").length > 0) {
    return { name: "Default", email: String(firebase.email) };
  }
  return { name: "Default", email: "" };
}
